import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react-v3'; 
import WorkflowExecutionsTable from './table/table.js';
import AppContext from "../../context/AppContext";
import ActivationRequired from "../../components/ActivationRequired";
import {getSidebarItemFromPageStage} from "../home/home";

class WorkflowExecutions extends React.Component {
    static contextType = AppContext;
    render() {
        return (
            <AppLayout
                content={<ActivationRequired userStatus={this.context && this.context.userStatus}><WorkflowExecutionsTable /></ActivationRequired>}
                navigation={<SideBar activeHref="/workflow_executions" items={getSidebarItemFromPageStage(this.context.pageStage)}/>}
                navigationOpen={true}
                onNavigationChange={() => {}}
                toolsHide={true}
            />
        );
    }
}

export default WorkflowExecutions;
